

import { Component, VModel, Vue } from "vue-property-decorator";
import IBDialog from "@/components/Dialog/IBDialog.vue";

@Component({
	components: {
		IBDialog
	}
})
export default class DigitalSignNotConnectedDialog extends Vue {

	@VModel({ type: Boolean })
	model!: boolean

	onConfirm() {
		window.open(
			'https://dbop.infinbank.com:9443/download/ikey_installation.zip'
		);

		this.model = false;
	}

}

